interface PartnershipLinksProps {
  label: string;
  link: string;
}

export interface PartnershipProps {
  mainText: string;
  links: PartnershipLinksProps[];
}

export interface RepaymentDateProps {
  date: string;
  translated: string;
}

export interface EmploymentContractProps {
  id: number;
  averageSalary: number;
  begin_date: string;
  bin: string;
  company_name: string;
}

export interface LeadProps {
  lead_id: number;
  approved_amount: number | null;
  approved_date: number | null;
  available_dates: RepaymentDateProps[];
  employments: EmploymentContractProps[];
  partnership_links: PartnershipProps | null;
  requested_amount: number | null;
  requested_date: number | null;
  status: LeadStatus;
  status_label: string;
}

export enum LeadStatus {
  TokenRequest = 0,
  PendingSMS = 1,
  Processing = 2,
  PendingVerification = 3,
  CustomerRefusal = 4,
  CustomerDenied = 5,
  PendingSubmit = 6,
  MoneyTransfer = 7,
  Converted = 8,
  Adjustments = 9,
  Closed = 10,
  LookingEmploymentContracts = 21,
  ChooseEmploymentContract = 22,
  ChooseLoanParams = 23,
  Registration = 999,
}
